import type { Plugin } from "vue";
import { createLocale } from "./locale";

export type { Numeric } from "d3";
export * from "./components";
export * from "./interfaces";
export * from "./use";

export { useLocale } from "./locale";

export function createD3Chart(): Plugin {
	return {
		install(app) {
			createLocale(app);
		},
	};
}
